import React, { Component } from 'react'
import ReactDatePicker from 'react-datepicker'
import DateSelectorInput from '../DateSelectorInput/DateSelectorInput'
import PropTypes from 'prop-types'
import moment, {
  dateFormatStringified,
  dateFormat,
} from '../../helpers/momentUtils'

class DateSelector extends Component {
  state = {
    value: '',
    outboundDate: '',
    inboundDate: '',
    suggestedInboundDate: {
      date: '',
      stringifiedDate: '',
    },
    suggestedOutboundDate: {
      date: '',
      stringifiedDate: '',
    },
  }

  handleTypeInput = (e, inputId) => {
    const state = { ...this.state }
    const suggestedDate = {}
    state[inputId] = e.target.value
    const date = this.getDateSuggestionFromInput(e.target.value)
    suggestedDate.stringifiedDate = moment(date, dateFormat).format(
      dateFormatStringified
    )
    suggestedDate.date = moment(date, dateFormat)
    if (inputId === 'inboundDate') {
      state.suggestedInboundDate =
        suggestedDate.stringifiedDate !== 'Invalid date'
          ? suggestedDate
          : { date: '', stringifiedDate: '' }
    }
    if (inputId === 'outboundDate') {
      state.suggestedOutboundDate =
        suggestedDate.stringifiedDate !== 'Invalid date'
          ? suggestedDate
          : { date: '', stringifiedDate: '' }
    }
    this.setState(state)
  }

  recogniseInputDateFormat = input => {
    if (new RegExp(/[a-zA-Z]/).test(input)) {
      return dateFormatStringified
    } else if (new RegExp(/-/).test(input)) {
      return dateFormat
    } else {
      return 'DD MM YYYY'
    }
  }

  getDateSuggestionFromInput = input => {
    const format = this.recogniseInputDateFormat(input)
    const today = moment()
    const currentYear = today.format('YYYY')
    const suggested = {
      day: moment(input, format).format('DD'),
      month: moment(input, format).format('MM'),
      year: moment(input, format).format('YYYY'),
    }
    if (suggested.year <= currentYear) {
      suggested.year = currentYear
      const { day: d, month: m, year: y } = suggested
      const suggestedDate = moment(`${d}-${m}-${y}`, dateFormat)
      if (suggestedDate.diff(today) < 0) {
        suggested.year = +currentYear + 1
      }
    }
    return `${suggested.day}-${suggested.month}-${suggested.year}`
  }

  updateInboundDate = date => {
    this.setState({
      inboundDate: '',
      suggestedInboundDate: { date: '', stringifiedDate: '' },
    })
    this.props.setInboundDate(date)
  }

  updateOutboundDate = date => {
    this.setState({
      outboundDate: '',
      suggestedOutboundDate: { date: '', stringifiedDate: '' },
    })
    this.props.setOutboundDate(date)
  }

  static getDerivedStateFromProps = (props, state) => {
    const selectedOutboundDateObject = moment(
      props.selectedOutboundDate,
      dateFormatStringified
    )
    const selectedInboundDateObject = moment(
      props.selectedInboundDate,
      dateFormatStringified
    )
    return {
      ...state,
      selectedOutboundDateObject,
      selectedInboundDateObject,
    }
  }

  render() {
    const {
      selectedOutboundDate,
      selectedInboundDate,
      labels,
      isMultipleDestination,
      isSingleFlight,
      toggleSingleFlightState,
    } = this.props
    const {
      selectedInboundDateObject,
      selectedOutboundDateObject,
      suggestedOutboundDate,
      suggestedInboundDate,
      outboundDate,
      inboundDate,
    } = this.state
    return (
      <div className="DateSelectorContainer">
        <ReactDatePicker
          customInput={
            <DateSelectorInput
              inputId="outboundDate"
              data-element="outboundDate"
              label={labels.inboundLabel}
              selected={selectedOutboundDate}
              autoComplete={true}
              handleType={this.handleTypeInput}
              suggestedDate={suggestedOutboundDate}
              setInboundDate={this.updateInboundDate}
              setSuggestedDate={this.updateOutboundDate}
              inputVal={outboundDate}
            />
          }
          selected={selectedOutboundDateObject}
          selectsStart
          minDate={moment()}
          startDate={selectedOutboundDateObject}
          endDate={selectedInboundDateObject}
          onChange={this.updateOutboundDate}
          popperPlacement="bottom-end"
          popperModifiers={{
            preventOverflow: {
              enabled: true,
              escapeWithReference: true, // force popper to stay in viewport (even when input is scrolled out of view)
              boundariesElement: 'viewport',
            },
          }}
        />
        <ReactDatePicker
          disabled={isSingleFlight}
          customInput={
            <DateSelectorInput
              inputId="inboundDate"
              data-element="inboundDate"
              disabled={isSingleFlight}
              label={labels.outboundLabel}
              selected={
                isSingleFlight ? labels.singleFlightLabel : selectedInboundDate
              }
              autoComplete={true}
              hasCheckbox={!isMultipleDestination}
              isChecked={!isSingleFlight}
              handleType={this.handleTypeInput}
              suggestedDate={suggestedInboundDate}
              handleCheckboxClick={toggleSingleFlightState}
              setSuggestedDate={this.updateInboundDate}
              inputVal={inboundDate}
            />
          }
          selected={selectedInboundDateObject}
          selectsEnd
          minDate={selectedOutboundDateObject}
          startDate={selectedOutboundDateObject}
          endDate={selectedInboundDateObject}
          onChange={this.updateInboundDate}
          popperPlacement="bottom-end"
          popperModifiers={{
            preventOverflow: {
              enabled: true,
              escapeWithReference: true, // force popper to stay in viewport (even when input is scrolled out of view)
              boundariesElement: 'viewport',
            },
          }}
        />
      </div>
    )
  }
}

DateSelector.propTypes = {
  setOutboundDate: PropTypes.func,
  setInboundDate: PropTypes.func,
  selectedOutboundDate: PropTypes.string,
  selectedInboundDate: PropTypes.string,
  labels: PropTypes.shape({
    inboundLabel: PropTypes.string,
    outboundLabel: PropTypes.string,
    singleFlightLabel: PropTypes.string,
  }),
  toggleSingleFlightState: PropTypes.func,
  isSingleFlight: PropTypes.bool,
  handleType: PropTypes.func,
  isMultipleDestination: PropTypes.bool,
}

export default DateSelector
